import { Injectable } from '@angular/core';
import { RequestMethod } from '@angular/http';
import { CustomHttp } from 'app/common/http/custom.http';
import { RequestConfig } from 'app/shared/rest/rest.request';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { BehaviorSubject, Observable } from 'rxjs-compat';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OfflineSalesActionsService {
  private VALIDATE_MODE_APP = new RequestConfig('GANTT001', 'application/json', true, RequestMethod.Get, '/bitacoraVentasOffline');
  private CHANGE_MODE_APP = new RequestConfig('GANTT001', 'application/json', true, RequestMethod.Post, '/bitacoraVentasOffline');

  constructor(private http: CustomHttp) { }

  public validateModeApp(): Observable<any> {
    return this.http.sendRequestToUrl(environment.Mega_url, this.VALIDATE_MODE_APP)
      .pipe(
        map((response: any) => (response.json())),
        catchError((error) => {
          try {
            error = error.json();
          } catch (e) { }
          return throwError(error);
        })
      );
    // let obervable = new BehaviorSubject<boolean>(false);
    // return obervable;
  }
  public changeModeApp(body): Observable<any> {
    return this.http.sendRequestToUrl(environment.Mega_url, this.CHANGE_MODE_APP, body)
      .pipe(
        map((response: any) => (response.json())),
        catchError((error) => {
          try {
            error = error.json();
          } catch (e) { }
          return throwError(error);
        })
      );
  }
}
@Injectable()
export class ChangeModeApp {
  estatusVenta: boolean;
  idUsuario: string;
}